import router from './router'
import { getToken } from '@/utils/auth' // get token from cookie
import store from './store'
import { refreshtoken } from '@/services/login'
const whiteList = ['/login', '/auth-redirect', '/sales'] // no redirect whitelist
router.beforeEach((to, from, next) => {
  if (getToken()) {
  // determine if there has token
  /* has token */
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetUserInfo').then(res => {

        })
        const roles = [{id: '1', name: 'admin'}]
        store.dispatch('GenerateRoutes', {roles}).then(accessRoutes => {
          router.addRoutes(accessRoutes)

          next({...to})
        })
      } else {
        next()
      }
    }
  } else {
  /* has no token */
    console.log(to.path)
    if (whiteList.indexOf(to.path) !== -1) {
    // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
    }
  }
  // } else {
  //   /* has no token */
  //   if (whiteList.indexOf(to.path) !== -1) {
  //     // 在免登录白名单，直接进入
  //     next()
  //   } else {
  //     if (getreToken()) {
  //       let reftokendata = {
  //         grant_type: 'refresh_token',
  //         refresh_token: getreToken().reTokenKey,
  //         client_id: 'op',
  //         client_secret: 'opsecret'
  //       }
  //       refreshtoken(reftokendata).then(response => {
  //         store.dispatch('LoginByrefresh', response).then(() => {

  //         }).catch(() => {
  //           next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
  //         })
  //       }, (response) => {
  //         next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
  //       })
  //     } else {
  //       next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
  //     }
  //   }
  // }
})

router.afterEach(() => {
})



// WEBPACK FOOTER //
// ./src/permission.js